import DataBase from "../dataBase/liquidGuides";
import { DateTime } from "luxon";

export default class User {
  constructor() {
    this.data = {
      distance_unit: "kilometers",
      date_format: "Month first",
      edit_mode: true,
      advanced_mode: false,
      email: "guest@gmail.com",
      first_name: "guest",
      last_name: "user",
      uid: "guest",
      create_date: "",
      modify_date: "",
      travel_payouts_marker: "",
      last_guide_id: "",
      last_guide_time: "",
      payment_info: "",
      affiliate_program: false,
    };
  }

  // data = () => {
  //   return this.data;
  // };

  static fixUser = (user) => {
    if (typeof user.distance_unit == "undefined") user.distance_unit = "miles";
    if (typeof user.date_format == "undefined") user.date_format = "Month first";
    if (typeof user.edit_mode == "undefined") user.edit_mode = "On";
    if (typeof user.advanced_mode == "undefined") user.advanced_mode = "Off";
    if (typeof user.email == "undefined") user.email = null;
    if (typeof user.first_name == "undefined") user.first_name = null;
    if (typeof user.last_name == "undefined") user.last_name = null;
    if (typeof user.uid == "undefined") user.uid = null;
    if (typeof user.create_date == "undefined") user.create_date = null;
    if (typeof user.modify_date == "undefined") user.modify_date = null;
    if (typeof user.travel_payouts_marker == "undefined") user.travel_payouts_marker = "";
    if (typeof user.last_guide_id == "undefined") user.last_guide_id = "";
    if (typeof user.last_guide_time == "undefined") user.last_guide_time = "";
    if (user.create_date === null || user.create_date === "") user.create_date = DateTime.now().toISO({ zone: "utc" });
    if (user.modify_date === null || user.modify_date === "") user.modify_date = DateTime.now().toISO({ zone: "utc" });
    return user;
  };

  // Each wrapper below used to stash its callback in a single shared
  // `this._callBack` static field and hand Firestore a shared, unbound
  // "...Callback" method. Two overlapping calls (e.g. resolving several
  // distinct uids in a forEach, as the Shared/Mine-tab "From"/"To" filters
  // do) would race: the second call's assignment overwrote the first's
  // callback before its async read completed, so the FIRST request's
  // response ended up invoked through the SECOND request's callback —
  // silently pairing one person's real data with another person's uid.
  // Each call now closes over its own callback instead, making concurrent
  // calls safe. Found 2026-10-01. Matches mobile's identical User.js fix.
  static addUser = (user, callback) => {
    //console.log("User: AddUser");
    DataBase.addUser(user, callback);
  };

  static updateUser = (user, user_id, callback) => {
    DataBase.updateUser(user, user_id, (res) => {
      //if (res.pass == true) res.res = this.fixUser(res.res);
      callback(res);
    });
  };

  static readUser = (uid, callback) => {
    DataBase.readUser(uid, (res) => {
      if (res.pass == true) res.res = this.fixUser(res.res);
      callback(res);
    });
  };

  static findUserByUID = (uid, callback) => {
    DataBase.findUserByUID(uid, (res) => {
      if (res.pass == true) res.res = this.fixUser(res.res);
      callback(res);
    });
  };

  static findUserByFBID = (fb_id, callback) => {
    DataBase.findUserByFBID(fb_id, (res) => {
      if (res.pass == true) res.res = this.fixUser(res.res);
      callback(res);
    });
  };

  static findUserByEmail = (email, callback) => {
    DataBase.findUserByEmail(email, (res) => {
      if (res.pass == true) res.res = this.fixUser(res.res);
      callback(res);
    });
  };
}
